'use client';

import { PrismicNextLink } from "@prismicio/next";
import { isFilled } from "@prismicio/client";

/**
 * @typedef {import("@prismicio/client").Content.LiensSlice} LiensSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<LiensSlice>} LiensProps
 * @type {import("react").FC<LiensProps>}
 */
const Liens = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}>
      <ul className="flex flex-col justify-start items-start gap-4 list-none m-0 p-0">
        {isFilled.keyText(slice.primary.section_title) && (
          <li className="m-0 p-0">{slice.primary.section_title}</li>
        )}
        {slice.primary.ctas.length > 0 &&
          slice.primary.ctas.map((cta, index,) => {
            return isFilled.link(cta) && (
              cta.variant === 'Lien'
                ? <li className="" key={index}>
                  <PrismicNextLink
                    key={index}
                    field={cta}
                    className="footer-text underline-moyam">
                    {cta.text}
                  </PrismicNextLink>
                </li>
                : <li key={index} className="email-text">
                  <a href={`mailto:${cta.text}`}>
                    {cta.text}
                  </a>
                </li>
            )
          })}
      </ul>
    </section>)
};

export default Liens;
